import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4 className="footer-title">
              <span className="logo-sky">Sky</span>
              <span className="logo-sight">Sight</span>
              <span> Analytics</span>
            </h4>
            <p>Empowering businesses with data-driven solutions for growth and successful exits.</p>
            <div className="social-links">
              <a href="https://linkedin.com/in/greg-skysight" className="social-link">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Our Solutions</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/why-exit-ready">ExitReady™</Link></li>
              <li><Link to="/whats-included">ScalePath™</Link></li>
              <li><Link to="/who-its-for">Who We Serve</Link></li>
              <li><Link to="/what-we-build">Case Studies</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Contact Us</h4>
            <ul className="footer-links">
              <li><a href="mailto:greg@skysightanalytics.com">greg@skysightanalytics.com</a></li>
              <li><a href="tel:+16472047295">+1 (647) 204-7295</a></li>
              <li>Toronto, Ontario<br />Canada</li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} SkySight Analytics. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;